import { getLocalStorageInfo } from "../../../../utils"

export const HtTableHeadMain = [
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },

	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },

	{ id: "Dimension", label: "Dimension", sortOption: true, colspan: 3 },
	{ id: "Next Due", label: "Next Due", sortOption: true, colspan: 3 },
	{ id: "Remaining", label: "Life Remaining", sortOption: true, colspan: 3 },

	{ id: "", label: "", sortOption: false },
	{ id: "", label: "", sortOption: false },
]

export const HtTableHead = [
	{ id: "actions", label: "Actions", sortOption: false },
	{ id: "ata_chapter", label: "ATA Chapter", sortOption: true },
	{ id: "part_description", label: "Part Description", sortOption: true },
	{ id: "part_number", label: "Part Number", sortOption: true },
	{ id: "part_serial_number", label: "Part Serial Number", sortOption: true },
	{
		id: "part_installation_date",
		label: "Part Installation Date",
		sortOption: true,
	},
	{
		id: "aircraft_tsn_installation",
		label: "Aircraft TSN at Installation",
		sortOption: true,
	},
	{
		id: "aircraft_csn_installation",
		label: "Aircraft CSN at Installation",
		sortOption: true,
	},

	{
		id: "part_tsn_installation",
		label: "Part TSN at Installation",
		sortOption: true,
	},
	{
		id: "part_csn_installation",
		label: "Part CSN at Installation",
		sortOption: true,
	},
	{ id: "ht_requirement", label: "HT Requirement", sortOption: true },

	{ id: "ht_interval_days", label: "Days", sortOption: false },
	{ id: "ht_interval_fh", label: "FH", sortOption: false },
	{ id: "ht_interval_fc", label: "FC", sortOption: false },

	{ id: "ht_last_done_date", label: "Date", sortOption: false },
	{ id: "ht_last_done_fh", label: "FH", sortOption: false },
	{ id: "ht_last_done_fc", label: "FC", sortOption: false },

	{ id: "ht_remaining_days", label: "Days", sortOption: false },
	{ id: "ht_remaining_fh", label: "FH", sortOption: false },
	{ id: "ht_remaining_fc", label: "FC", sortOption: false },

	{ id: "remark", label: "Remarks",sortOption: true },
	{ id: "attachments", label: "Attachments" },
]

export const assetFilterOps = {
	aircraft_type: {
		inputType: "dropdown",
		placeholder: "Select Aircraft Type",
		title: "Aircraft Type",
		options: [],
		labelKey: "name",
		valueKey: "id",
		multiple: true,
	},
	engine_type: {
		inputType: "dropdown",
		placeholder: "Select Engine Type",
		title: "Engine Type",
		options: [],
		labelKey: "name",
		valueKey: "id",
		multiple: true,
	},
	lessee: {
		inputType: "dropdown",
		placeholder: "Select Lessee",
		title: "Lessee",
		options: [],
		labelKey: "name",
		valueKey: "slug",
		multiple: true,
	},
	lessor_name: {
		inputType: "text",
		placeholder: "Enter Lessor",
		title: "Lessor",
	},
	owner: {
		inputType: "text",
		placeholder: "Enter Owner ",
		title: "Owner",
	},
	ownership_type: {
		inputType: "dropdown",
		placeholder: "Select Ownership Type",
		title: "Ownership",
		options: [
			{ label: "Owned", value: 1 },
			{ label: "Managed", value: 2 },
		],
		labelKey: "label",
		valueKey: "value",
		multiple: true,
	},
	registration: {
		inputType: "text",
		placeholder: "Enter Registeration Number",
		title: "Registeration Number",
	},
	portfolio: {
		inputType: "text",
		placeholder: "Enter Portfolio",
		title: "Portfolio",
	},
	serial_number: {
		inputType: "text",
		placeholder: "Enter Serial Number",
		title: "Serial Number",
	},
	status: {
		inputType: "dropdown",
		placeholder: "Select Status",
		title: "Status",
		options:
			getLocalStorageInfo() &&
				getLocalStorageInfo().defaultLessor &&
				getLocalStorageInfo().defaultLessor.id === 442
				? [
					{ label: "Prospect", value: "11" },
					{ label: "In Storage", value: "10" },
					{ label: "Lease Return", value: "9" },
					{ label: "MOU Signed", value: "8" },
					{ label: "MOU Issued", value: "7" },
					{ label: "Lease Issued", value: "6" },
					{ label: "Archive", value: "5" },
					{ label: "Written Off/ Sold / Part out", value: "4" },
					{ label: "OnGround", value: "3" },
					{ label: "Off Lease", value: "2" },
					{ label: "On Lease", value: "1" },
				]
				: [
					{ label: "Archive", value: "5" },
					{ label: "On Lease", value: "1" },
					{ label: "Off Lease", value: "2" },
					{ label: "On Ground", value: "3" },
					{ label: "Written Off/ Sold / Part out", value: "4" },
				],
		labelKey: "label",
		valueKey: "value",
		multiple: true,
	},
}
